import { Flex } from '@chakra-ui/react'
import { CardProducts } from '../Produtos/CardProducts'
import { Trow } from '../Produtos/Trow'
import { format } from 'date-fns'
import { Balanco } from '../Produtos/Balanco'
import { formatPrice } from '../../../../../utils/formatPrice'
import { memo } from 'react'

const RowTable = ({ item, index, openModal }) => {
  function firstLetterUpper(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  }

  const valorNota = item?.produtos?.reduce((acc, item) => {
    const { valor_unit, icms_st, quantidade_negociada } = item

    const valorUnit = parseFloat(valor_unit) || 0
    const qtdNegociada = parseInt(quantidade_negociada) || 0
    const icmsSt = parseFloat(icms_st) || 0

    const soma = valorUnit * qtdNegociada + icmsSt

    return acc + soma
  }, 0)

  //soma valorNota com destacado_nota
  const valorTotalNota = valorNota + parseFloat(item.destacado_nota)


  return (
    <Flex
      flexDir="column"
      alignItems="flex-end"
      key={0}
      cursor="pointer"
      fontFamily={'heading'}
      letterSpacing={'wide'}
      onClick={() => openModal(item)}
      bgColor={parseFloat(item.valor_nota) > valorTotalNota ? 'red.200' : ''}
    >
      <Flex flex={1} gap={'.1rem'}>
        <Trow
          value={
            item.Dtalter ? format(new Date(item.Dtalter), 'dd/MM/yyyy') : ''
          }
          index={2}
        />
        <Trow value={item.Numinno} index={3} />
        <Trow
          value={
            item.razao_social.length > 20
              ? firstLetterUpper(item.razao_social.substring(0, 20)) + '...'
              : firstLetterUpper(item.razao_social)
          }
          width="12.5rem"
          index={4}
        />
        <Trow
          value={
            formatPrice(item.valor_nota)
            // formatPrice(valorNota)
          }
          index={5}
        />
        <Trow
          value={
            // formatPrice(item.valor_nota)
            formatPrice(valorNota + parseFloat(item.destacado_nota))
          }
          index={5}
        />
        <Flex flexDir="column" flex={1}>
          {item?.produtos.map((item, index) => (
            <CardProducts
              index={index}
              key={index}
              item={item}
              onClick={() => openModal(item)}
              firstLetterUpper={firstLetterUpper}
            />
          ))}
        </Flex>
      </Flex>
      <Balanco item={item} index={index} />
    </Flex>
  )
}

export default memo(RowTable)
